import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import type { TaskStatus, TaskPriority } from '../../../../types';

interface DroppableZoneProps {
  id: string;
  status: TaskStatus;
  priority?: TaskPriority;
  children: React.ReactNode;
  className?: string;
}

export const DroppableZone: React.FC<DroppableZoneProps> = ({
  id,
  status,
  priority,
  children,
  className = ''
}) => {
  const { isOver, setNodeRef } = useDroppable({
    id,
    data: {
      type: 'zone',
      status,
      priority
    }
  });

  return (
    <div
      ref={setNodeRef}
      className={`
        ${className}
        ${isOver ? 'drop-zone-highlight' : ''}
        transition-all duration-200
      `}
      data-status={status}
      data-priority={priority}
      style={{ minHeight: className?.includes('min-h-') ? undefined : '80px' }}
    >
      {children}
    </div>
  );
};